import React, { useEffect, useState, useRef } from "react";
import LayersControl from './layers-control/layers-control';
import PanelButton from './panel-button/panel-button';
import layerPickerImage from './layers.svg'
import infoImage from './info.svg'
import homeImage from './home.svg'
import { _layers, _terrain } from "../../utils/layers";
import InitializeViewer, {
  updateLayerVisible,
  updateLayerOpacity,
  unselectFeature,
  focusOnSelectedEntity,
  focusOnHome,
  setReactStateFunctions,
  setTerrainProvider
} from "../../services/viewer/viewer"
import styles from './3d-map.module.css'
import FeatureDescription from "./feature-description/feature-description";
import ViewerInfoPanel from './info-panel/info-panel'
import ZoomLevel from "./zoom-level/zoom-level";

export default function Map() {
  const [zoomLevel, setZoomLevel] = useState(1);
  const [layers, setLayers] = useState(_layers);
  const [initialization, setInitialization] = useState(true);
  const callbackFunction = useRef(undefined);
  const [layersCollapsed, setLayersCollapsed] = useState(true);
  const [infoCollapsed, setInfoCollapsed] = useState(true);
  const [selectedFeature, setSelectedFeature] = useState({ visible: false });
  const [terrain, setTerrain] = useState(_terrain);

  function findLayer(equalFunc) {
    let foundLayer = undefined;
    let findLayerFromEl = (layer) => {
      if (equalFunc(layer)) {
        foundLayer = layer;
      }
      else if (layer.elements)
        layer.elements.forEach((l) => findLayerFromEl(l));
    }
    layers.forEach((l, i) => findLayerFromEl(l));
    return foundLayer;
  };

  function changeLayer(layer) {
    let changeChildrenLayer = (l) => {
      if (l.id === layer.id)
        return layer;
      let nl, newLayer = undefined;
      if (l.elements)
        for (let i = 0; i < l.elements.length; i++) {
          nl = changeChildrenLayer(l.elements[i]);
          if (nl) {
            newLayer = { ...l };
            newLayer.elements[i] = nl;
            break;
          }
        }
      return newLayer;
    };
    let newLayer;
    for (let i = 0; i < layers.length; i++) {
      newLayer = changeChildrenLayer(layers[i]);
      if (newLayer) {
        let newLayers = [...layers];
        newLayers[i] = newLayer;
        setLayers(newLayers);
        break;
      }
    }
  };
  setReactStateFunctions(findLayer, changeLayer);

  if (callbackFunction.current) {
    callbackFunction.current();
    callbackFunction.current = undefined;
  }

  useEffect(() => {
    if (initialization) {
      setInitialization(false);
      InitializeViewer(layers, selectedFeature, setSelectedFeature, _terrain.elements.find(e => e.visible), setZoomLevel);
    }
  }, [initialization]);
  return (
    <div className={styles.content}>
      <div id="cesiumContainer" className={styles.cesiumContainer}></div>
      <div className={styles.panelButtons}>
        <PanelButton
          imageSrc={infoImage}
          onClickFunction={() => {
            if (!layersCollapsed)
              setLayersCollapsed(!layersCollapsed);
            setInfoCollapsed(!infoCollapsed);
          }}
          className={infoCollapsed ? null : styles.panelButtonSelected}
        />
        <PanelButton
          imageSrc={homeImage}
          onClickFunction={() => focusOnHome()}
        />
        <PanelButton
          imageSrc={layerPickerImage}
          onClickFunction={() => {
            if (!infoCollapsed)
              setInfoCollapsed(!infoCollapsed);
            setLayersCollapsed(!layersCollapsed);
          }}
          className={layersCollapsed ? null : styles.panelButtonSelected}
        />
      </div>
      <FeatureDescription
        visible={selectedFeature.visible}
        feature={selectedFeature.feature}
        layerLabel={selectedFeature.layer?.label}
        onHideButtonClick={() => unselectFeature()}
        onFocusElementClick={focusOnSelectedEntity}
      />
      <LayersControl
        layers={layers}
        layersCollapsed={layersCollapsed}
        setLayers={setLayers}
        updateLayerVisible={updateLayerVisible}
        updateLayerOpacity={updateLayerOpacity}
        changeLayer={changeLayer}
        callbackFunction={callbackFunction}
        terrain={terrain}
        setTerrain={setTerrain}
        setTerrainProvider={setTerrainProvider}
      />
      <ViewerInfoPanel
        collapsed={infoCollapsed}
      />
      <ZoomLevel
        zoomLevel={zoomLevel}
      />
    </div>
  );
}

